import { render } from "./ShipmentList.vue?vue&type=template&id=4f0daa91"
import script from "./ShipmentList.vue?vue&type=script&lang=js"
export * from "./ShipmentList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__